import Highway from "@dogstudio/highway";
import { addClass, removeClass } from "@qneyraud/q-utils";

export default class DefaultTransition extends Highway.Transition {
  out({ from, done }) {
    addClass(document.documentElement, "loading");
    from.parentNode.removeChild(from);
    done();
  }

  in({ done }) {
    removeClass(document.documentElement, "loading");
    document.body.classList.remove("noscroll");
    done();
  }
}



// WEBPACK FOOTER //
// ./scripts/transitions/defaultTransition.js